// extracted by mini-css-extract-plugin
export default {"wrapper-name":"HeaderProfile_wrapper-name__2N+Fg","wrapper-attributes":"HeaderProfile_wrapper-attributes__y0mzN","attribute-item":"HeaderProfile_attribute-item__3ul-j"};